(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bridgman-faq-template"]) return;
  try {
    
  (function () {
    $('body').on('click', '.bridgman_faq__question', function () {
      $(this).next('.bridgman_faq__answer').slideToggle(150).toggleClass('active');
      $(this).toggleClass('active');
    });

    $(document).on('shopify:block:select', '#shopify-section-page-bridgman_faq-template', function (event) {
      $(event.target).find('.bridgman_faq__answer').slideDown(150);
    });

    $(document).on('shopify:block:deselect', '#shopify-section-page-bridgman_faq-template', function (event) {
      $(event.target).find('.bridgman_faq__answer').slideUp(150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridgman-store-features"] && !Shopify.designMode) return;
  try {
    

  function setEventListeners ( ) 
  {
    window.addEventListener('resize', function ( ) {
        var currentWidth = window.innerWidth;
        if ( currentWidth < 769 ) {
          startAccordian( );
        }
        else {
          var text = document.getElementsByClassName( '.store_features_support_text_container' );
          text.style.maxHeight = text.scrollHeight + "px";
        }
    });
    var currentWidth = window.innerWidth;
    if ( currentWidth < 769 )
    {
      startAccordian( );
    }
  }

  function startAccordian ( )
  {
      var features = document.getElementsByClassName( 'feature-header-container' );
      for ( var i = 0; i < features.length; i++ ) {
        features[ i ].addEventListener( "click", function( ) 
        {
          var text = this.nextElementSibling;
          var close = this.querySelector( '.text_container_closer' );
          if ( text.style.maxHeight == 0 )
          {
            text.style.maxHeight = text.scrollHeight + "px";
            close.classList.add( 'text_container_closer--active' )   
          }
          else
          {
              text.style.maxHeight = null;
              close.classList.remove( 'text_container_closer--active' );
          }   
        });
      }
  }

  setEventListeners( );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
